import { equals, find, ifElse, includes, isEmpty, isNil, o, or } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { useMobileAuth } from '../contexts/mobileAuthContext';
import { useTerminalAuth } from '../contexts/terminalAuthContext';
import { UserRoles } from '../types/applicationUser.types';

export const useIsTaskCreatePermission = (): [
  hasPermissionToCreateTask: boolean,
  loading: boolean,
] => {
  const { pathname } = useLocation();
  const { user: authUser, loading } = useAuth();
  const { user: mobileUser } = useMobileAuth();

  const { user: terminalUser } = useTerminalAuth();

  return [
    o(
      (r) => !or(isNil(r), isEmpty(r)),
      find<UserRoles>((r) => equals(UserRoles.TaskCreate, r)),
    )(
      // @ts-ignore
      ifElse(
        // @ts-ignore
        includes('/terminal'),
        () => terminalUser?.roles,
        () =>
          ifElse(
            // @ts-ignore
            includes('/mobile'),
            () => mobileUser?.roles,
            () => authUser?.roles,
          )(pathname),
      )(pathname),
    ),
    loading,
  ];
};
